import { Modal } from "react-bootstrap";
import styles from "./InfluencerVideoModal.module.css";

const InfluencerVideoModal = ({ show, handleClose, modalData }) => {
  return (
    <Modal
      show={show}
      size="lg"
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className={styles.iframeWrapper}>
          <iframe
            width="560"
            height="315"
            src={`https://www.youtube.com/embed/${modalData?.data?.url}`}
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InfluencerVideoModal;
